import React, { useState } from "react";
import { Layout } from "../components/layout";
import { SEO } from "../components/common/SEO";
import { ContactForm, ContactInfo } from "../components/contact";

export function ContactPage() {
  const [status, setStatus] = useState<
    "idle" | "sending" | "success" | "error"
  >("idle");

  const handleSubmit = async (formData: {
    name: string;
    email: string;
    subject: string;
    message: string;
  }) => {
    setStatus("sending");

    try {
      const response = await fetch("https://api.voltblocks.com/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          recipient: "contact@voltblocks.com",
        }),
      });

      if (!response.ok) throw new Error("Failed to send message");

      setStatus("success");
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <Layout>
      <SEO
        title="Contact Us | Block Pattern Generator Support"
        description="Get in touch with our team for support, feature requests, or partnership inquiries. We're here to help you create better WordPress blocks."
        keywords={[
          "contact support",
          "wordpress help",
          "block pattern support",
          "pattern generator contact",
        ]}
      />

      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-3xl font-bold text-white mb-4">Contact Us</h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Have questions or need help? Our team is here to assist you with any
            inquiries about our WordPress block pattern generator.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <ContactForm onSubmit={handleSubmit} status={status} />
          </div>
          <div className="md:col-span-1">
            <ContactInfo />
          </div>
        </div>
      </div>
    </Layout>
  );
}
